/* Northsheep — opens the EU legal guarantee notice (snippets/ns-eu-notice).
   Delegated from document: the cart drawer and the collection grid are
   re-rendered wholesale, so listeners bound to the links would be lost. The
   notice image has no src until first needed, so it is never downloaded on a
   page view where nobody opens it; hovering or focusing a link starts the
   download so the first click shows the notice at once. */
(function () {
  if (window.__nsEuNotice) return;
  window.__nsEuNotice = true;

  function dialog() {
    return document.getElementById('NsEuNotice');
  }

  function prime(d) {
    var img = d && d.querySelector('img[data-src]');
    if (!img) return;
    img.src = img.getAttribute('data-src');
    img.removeAttribute('data-src');
  }

  function close(d) {
    if (typeof d.close === 'function') d.close();
    else d.removeAttribute('open');
  }

  document.addEventListener('click', function (event) {
    var d = dialog();
    if (!d) return;

    if (event.target.closest('[data-ns-eu-notice]')) {
      event.preventDefault();
      prime(d);
      if (typeof d.showModal === 'function') d.showModal();
      else d.setAttribute('open', '');
      return;
    }

    if (!d.open) return;
    // The close button, or a click on the backdrop (the event lands on the
    // dialog element itself, never on its content).
    if (event.target.closest('[data-ns-eu-notice-close]') || event.target === d) {
      close(d);
    }
  });

  function warm(event) {
    if (event.target.closest && event.target.closest('[data-ns-eu-notice]')) prime(dialog());
  }
  document.addEventListener('mouseover', warm);
  document.addEventListener('focusin', warm);
})();
